import { Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';

import { Layout } from './Components/Layout';

export const Chapter = ({ send }: StepComponentProps) => (
  <Layout title="Chapter or fiscal sponsee" send={send}>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Identify if Your Organization Operates as a Local Chapter of a Larger Nonprofit or have a
      fiscal sponsor
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      If your organization does not have its own 501(c) status, you’ll need the parent organization
      or fiscal sponsor to claim their profile on Deed and then add your organization.
    </Typography>
    <Typography fontSize={15} lineHeight="38px">
      For more information about parent and child organizations, please visit our knowledge hub{' '}
      <a
        href="https://www.notion.so/joindeed/Walmart-Deed-Knowledge-Hub-4654d7959f5d49c0b873cb848942015b"
        target="_blank"
        style={{ textDecoration: 'underline' }}
      >
        here
      </a>
      .
    </Typography>
  </Layout>
);
